import React from "react";

export function useMeasureElementWidth<T extends HTMLElement>(
  deps: React.DependencyList = [],
) {
  const ref = React.useRef<T | null>(null);
  const [measuredWidth, setMeasuredWidth] = React.useState<number>(0);

  React.useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;

    let animationFrame: number | null = null;

    const update = () => {
      const rect = element.getBoundingClientRect();
      const nextWidth = Math.ceil(rect.width);
      setMeasuredWidth((prev) => (prev !== nextWidth ? nextWidth : prev));
    };

    const observer = new ResizeObserver(() => {
      if (animationFrame != null) cancelAnimationFrame(animationFrame);
      animationFrame = requestAnimationFrame(update);
    });

    observer.observe(element);
    // Initialize immediately
    update();

    return () => {
      if (animationFrame != null) cancelAnimationFrame(animationFrame);
      observer.disconnect();
    };
  }, deps);

  return { ref, measuredWidth } as const;
}
